import { Tags } from "@/enum/tags";

import { apiSlice } from "../http";
import {
  JustificationsResponse,
  LabelAuditExportFilter,
  LabelAuditFilter,
  LabelAuditResponse,
  MonitoringFilter,
  PriceRemarkExportResult,
  ProductivityRow,
} from "./types";

const NO_CONTENT = 204;

function appendIf(params: URLSearchParams, key: string, value?: string | null) {
  if (value != null && value !== "") params.set(key, String(value));
}

function monitoringParams(filter: MonitoringFilter): string {
  const params = new URLSearchParams({
    dtIni: filter.dtIni,
    dtFim: filter.dtFim,
  });
  appendIf(params, "loja", filter.loja != null ? String(filter.loja) : null);
  appendIf(params, "tipo", filter.tipo);
  return params.toString();
}

function labelAuditParams(filter: LabelAuditExportFilter): URLSearchParams {
  const params = new URLSearchParams({
    loja: String(filter.loja),
    dtIni: filter.dtIni,
    dtFim: filter.dtFim,
  });
  appendIf(params, "tipo", filter.tipo);
  appendIf(params, "status", filter.status);
  appendIf(params, "confere", filter.confere);
  appendIf(params, "vigencia", filter.vigencia);
  appendIf(params, "sortBy", filter.sortBy);
  appendIf(params, "sortOrder", filter.sortOrder);
  return params;
}

export const priceRemarkMonitoringApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPriceRemarkProductivity: builder.query<
      ProductivityRow[],
      MonitoringFilter
    >({
      query: (filter) => ({
        url: `/price-remark/productivity?${monitoringParams(filter)}`,
        method: "GET",
      }),
      transformResponse: (response: ProductivityRow[]) => response || [],
      providesTags: [Tags.PRICE_REMARK_PRODUCTIVITY],
    }),
    getPriceRemarkJustifications: builder.query<
      JustificationsResponse,
      MonitoringFilter
    >({
      query: (filter) => ({
        url: `/price-remark/justifications?${monitoringParams(filter)}`,
        method: "GET",
      }),
      transformResponse: (response: JustificationsResponse) =>
        response || { resumo: [], excecoes: [] },
      providesTags: [Tags.PRICE_REMARK_JUSTIFICATIONS],
    }),
    getPriceRemarkLabelAudit: builder.query<
      LabelAuditResponse,
      LabelAuditFilter
    >({
      query: (filter) => {
        const params = labelAuditParams(filter);
        params.set("page", String(filter.page));
        params.set("perPage", String(filter.perPage));
        return {
          url: `/price-remark/label-audit?${params.toString()}`,
          method: "GET",
        };
      },
      transformResponse: (response: LabelAuditResponse) =>
        response || { data: [], total: 0 },
      providesTags: [Tags.PRICE_REMARK_LABEL_AUDIT],
    }),
    exportPriceRemarkLabelAudit: builder.mutation<
      PriceRemarkExportResult,
      LabelAuditExportFilter
    >({
      query: (filter) => ({
        url: `/price-remark/label-audit/export?${labelAuditParams(filter).toString()}`,
        method: "POST",
        responseHandler: async (response: Response) => {
          if (response.status === NO_CONTENT) return null;
          return response.json();
        },
      }),
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetPriceRemarkProductivityQuery,
  useGetPriceRemarkJustificationsQuery,
  useGetPriceRemarkLabelAuditQuery,
  useExportPriceRemarkLabelAuditMutation,
} = priceRemarkMonitoringApi;
